import { GlobalState, UI } from '@leverege/ui-redux';
import { ns } from '@leverege/i18n';
import utils from "../../editors/ImagineImageEditor/fileUtils.js";
const {
  t
} = ns('molten.imagine.forms.validators.resourceImageValidator');
export default attr => ({
  active: true,
  allow: (value, field, data) => {
    const file = value?.[0];
    if (utils.checkFileSize(file, 2 * 1000 * 1000) !== true) {
      GlobalState.dispatch(UI.set(`imageError/${field}`, utils.checkFileSize(file, 2 * 1000 * 1000)));
      return false;
    }
    GlobalState.dispatch(UI.set(`imageError/${field}`, false));
    return true;
  },
  submitValidator: (value, field, data) => {
    if (attr.blueprint?.attribute?.getTagStartingWith?.('imageRequired') && !value) {
      return t('requiredError', {
        attrName: attr.displayName
      });
    }
    const file = value?.[0];
    return utils.checkFileSize(file, 2 * 1000 * 1000);
  }
});